export default function CalendarHeadingCell({ dayOfWeek }: { dayOfWeek: string }) {
    return (
        <th className="w-1/7 day_of_week text-white font-auditorium text-2xl text-center font-normal py-3 border-grey border">
            {dayOfWeek}
        </th>
    );
}
